import { useCallback } from "react";
import { trpc } from "@lango/api";
import { Language } from "@lango/api/src/types";
import { useBot } from "@/api/useBot";
import { useUser } from "@/api/useUser";

export const useTranslate = () => {
  const { data: bot } = useBot();
  const { data: user } = useUser();
  const {
    data,
    mutateAsync,
    isLoading,
    reset,
  } = trpc.translateText.useMutation();

  const translate = useCallback(
    async (text: string, from: Language = bot!.language) => {
      return mutateAsync({
        text,
        from,
        to: user!.language,
      });
    },
    [mutateAsync, bot]
  );

  const translateTo = useCallback(
    async (text: string) => {
      return mutateAsync({
        text,
        from: user!.language,
        to: bot!.language,
      });
    },
    [mutateAsync, bot]
  );

  return {
    data,
    translate,
    translateTo,
    reset,
    isLoading,
  };
};
